/**
 * Public cache in front of the plataforma bucket. Object keys stay the same;
 * only the host changes. The database keeps the legacy S3 URL.
 */
export const LEGACY_S3_HOST = 'qualidoc-plataforma.s3.us-east-2.amazonaws.com';

export const STATIC_ASSET_ORIGIN = 'https://static.qualidoc.com.br';

const STATIC_ASSET_HOST = 'static.qualidoc.com.br';

function replaceHost(value: string): string {
  return value
    .split(`https://${LEGACY_S3_HOST}`)
    .join(STATIC_ASSET_ORIGIN)
    .split(`http://${LEGACY_S3_HOST}`)
    .join(STATIC_ASSET_ORIGIN)
    .split(`//${LEGACY_S3_HOST}`)
    .join(`//${STATIC_ASSET_HOST}`);
}

/**
 * Rewrites a stored S3 URL (or HTML that contains one) to the static host.
 * Other hosts, relative paths, and empty values are returned unchanged.
 * Safe to call more than once.
 */
export function rewriteStaticAssetUrl<T extends string | null | undefined>(
  value: T,
): T {
  if (!value || !value.includes(LEGACY_S3_HOST)) return value;
  return replaceHost(value) as T;
}

/** Same rewrite for `next/image` src values. Static imports are left as-is. */
export function rewriteStaticAssetSrc<T>(src: T): T {
  if (typeof src !== 'string') return src;
  return rewriteStaticAssetUrl(src) as T;
}

/** True when the URL should be loaded by the browser from the static host. */
export function isStaticAssetCdnSrc(src: unknown): boolean {
  if (typeof src !== 'string' || !src) return false;
  try {
    const absolute = src.startsWith('//') ? `https:${src}` : src;
    return new URL(absolute).hostname === STATIC_ASSET_HOST;
  } catch {
    return false;
  }
}
